import React from 'react';
import type { CollapseProps as BaseCollapseProps } from 'antd';

import { Collapse } from './styled.ts';
export type { BaseCollapseProps };

export const BaseCollapse: React.FC<BaseCollapseProps> = ({ className, ...props }) => (
    <Collapse className={className} {...props} />
);
